
const lastUpdate = '2026-03-15';
export const helpTitle = 'Reissue Tools';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Reissue Tools panel allows administrators to regenerate and redistribute daily report products on demand. Use this when a report needs to be corrected and resent, or when a distribution was missed.</p>

<h2>Available Products</h2>
<ul>
  <li><strong>Lightning Map</strong> — Daily lightning strike map.</li>
  <li><strong>Fire Situation Map</strong> — Current fire situation overview map.</li>
  <li><strong>Rain Report</strong> — Daily precipitation summary.</li>
  <li><strong>Weather Report (9am)</strong> — Morning weather observation summary.</li>
  <li><strong>Weather Report (1300)</strong> — Afternoon weather observation summary.</li>
  <li><strong>Weather Report (1700)</strong> — Evening weather observation summary.</li>
</ul>

<h2>Actions</h2>
<ul>
  <li><strong>Regenerate</strong> — Rebuilds the selected report product using current data.</li>
  <li><strong>Email Resend</strong> — Resends the product to the configured distribution list.</li>
  <li><strong>Download</strong> — Downloads the current day's product directly without resending.</li>
</ul>

<p><em>This tool is available to administrators only.</em></p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
